/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./category-box.vue?vue&type=template&id=2cce7d33&scoped=true&"
import script from "./category-box.vue?vue&type=script&lang=js&"
export * from "./category-box.vue?vue&type=script&lang=js&"
import style0 from "./category-box.vue?vue&type=style&index=0&id=2cce7d33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce7d33",
  null
  
)

export default component.exports